// core version + navigation, pagination modules:
import Swiper from 'swiper';
import { Pagination, Autoplay, Navigation } from 'swiper/modules';

// import Swiper and modules styles
import 'swiper/css';
import 'swiper/css/autoplay';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

const isAutoplay = document.querySelector( '.gallery-carousel' ).dataset.autoplay === 'true';

// eslint-disable-next-line no-unused-vars
const swiper = new Swiper( '.gallery-carousel', {
	// configure Swiper to use modules.
	modules: [ Navigation, Pagination, Autoplay ],
	// Default parameters.
	autoplay: isAutoplay ? { delay: 3500, disableOnInteraction: true } : false,
	navigation: {
		nextEl: '.swiper-button-next',
		prevEl: '.swiper-button-prev',
	},
	slidesPerView: 1,
	speed: 400,
	loop: true,
	pagination: {
		clickable: true,
		el: '.swiper-pagination',
	},
	spaceBetween: 24,
	// Responsive breakpoints.
	breakpoints: {
		480: {
			slidesPerView: 2,
		},
		768: {
			slidesPerView: 3,
		},
	},
} );
